import type { ConversationNodePhoneNumber } from 'lib-shared-types-api';

type RoutedThroughLocationProps = {
  node: ConversationNodePhoneNumber;
};

export function RoutedThroughLocation({
  node,
}: RoutedThroughLocationProps): JSX.Element {
  return (
    <>
      Location ·{' '}
      {node.match === true ? <strong>{node.name}</strong> : 'No match'}
    </>
  );
}
